var base2 = window.base2;
var base1 = window.base1;
var base = window.base;
var base, base1, base2;
window.Certifications || (window.Certifications = {});
(base = window.Certifications).Modals || (base.Modals = {});
(base1 = window.Certifications).Components || (base1.Components = {});
(base2 = window.Certifications).Pages || (base2.Pages = {});
window.define = null;
window.base = base;
window.base1 = base1;
window.base2 = base2;